<template>
	<div >
		<!-- <div class="comment-textarea" sticky-offset="{top: 86}" v-sticky="stickyEnabled" on-stick="onStick" sticky-z-index="20"> -->
		<div class="comment-textarea" v-sticky="stickyEnabled" on-stick="onStick" sticky-z-index="20">
			<form @submit.prevent="insertMessage">
				<textarea placeholder="Type something here.." v-model="message"></textarea>
				<button type="submit" class="text-submit">Comment</button>
				<button type="submit" class="icon-submit">
					<svg width="19px" height="20px" viewBox="0 0 19 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
					  <path d="M17.7762 8.37578L1.78536 0.129953C0.948973 -0.30134 0 0.393614 0 1.43762L0 5.72853C0 6.63562 0.564191 7.41644 1.34716 7.59254L7.19955 8.90964C7.94549 9.07727 7.94549 10.2896 7.19955 10.4575L1.34716 11.7746C0.564191 11.9507 0 12.7313 0 13.6386L0 17.9293C0 18.9733 0.948973 19.6685 1.78536 19.2369L17.7762 10.9914C18.7647 10.4814 18.7647 8.88545 17.7762 8.37578" id="Fill-1" fill="#00C6C6" stroke="none" />
					</svg>			
				</button>
			</form>
		</div>

		<div class="comments-wrap">
			<div class="comment-single" v-for="(comment, index) in comments" :key="index">
				<div class="commented-user-img">
					<img :src="require(`@/assets/images/users/${comment.photo}`)"  />
				</div>
				<div class="single-comment-details">
					<div class="comment-header">
						<router-link :to="{ name: 'profile', params: { name: comment.username }}">
							<h4>{{ comment.name }}</h4>
						</router-link>
						<p>{{ comment.time }}</p>
					</div>
					<div class="comment-body">
						<truncate 
                        collapsed-text-class="collapsed" 
                        clamp="more" 
                        less=''
                        :length="200"
                        type="html" 
                        :text="comment.message"></truncate>
					</div>
					<div class="comment-footer">
						<div class="comment-footer-left">
							<comment-reaction :postReaction="comment.reactions"></comment-reaction>
							<button href="#reply" type="button" @click="replyTextareaOpen(index,comment.name )">Reply</button>
						</div>
						<div class="comment-footer-right">
		                    <base-dropdown>
		                        <div slot="title">
									<button type="button">
										<svg width="3px" height="13px" viewBox="0 0 3 13" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
										  <g id="more-vertical" transform="translate(0.5 0.5)">
										    <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" transform="translate(0 4.941176)" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
										    <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
										    <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" transform="translate(0 9.882353)" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
										  </g>
										</svg>
									</button>
		                        </div>
		                        <template>
		                        	<li>
			                            <a href="#">
			                               Block
			                            </a>
		                            </li>
		                        	<li>
			                            <a href="#">
			                               Block & Report
			                            </a>
		                            </li>
		                        </template>
		                    </base-dropdown>
						</div>
					</div>

 					<!-- Comment Reply Textarea Start -->
					<div class="reply-textarea" v-if="comment.isReplyOpen">
						<form @submit.prevent="msgReplay">
							<html-textarea id="reply" v-model="cmntReply.message"></html-textarea>
							<!-- <textarea v-html="reply"></textarea> -->
							<button type="submit">Reply</button>
						</form>
					</div> 
					<!-- Comment Reply Textarea End -->

					<!--Comment Wrap Start -->
					<div class="hide-reply" v-if="comment.replys.length>0" @click="comment.hideAllReply=!comment.hideAllReply">
						<span></span>
						<small v-show="comment.hideAllReply==true">Hide replies</small>
						<small v-show="comment.hideAllReply==false">Show replies</small>
					</div>
					<!-- /. Hide Reply -->

					<div class="comment-reply-wrap" v-if="comment.replys && comment.hideAllReply==true">
						<div class="comment-reply-single comment-single" v-for="(reply, key) in comment.replys" :key="key">
							<div class="commented-user-img">
								<img :src="require(`@/assets/images/users/${reply.photo}`)"  />
							</div>
							<div class="single-comment-details">
								<div class="comment-header">
									<router-link :to="{ name: 'profile', params: { name: reply.username }}">
										<h4>{{ reply.name }}</h4>
									</router-link>
									<p>{{ reply.time }}</p>
								</div>
								<div class="comment-body">
									<truncate 
				                        collapsed-text-class="collapsed" 
				                        clamp="more" 
				                        less=''
				                        :length="190"
				                        type="html" 
				                        :text="reply.message">
				                    </truncate>
								</div>
								<div class="comment-footer">
									<div class="comment-footer-left">
										<comment-reaction :postReaction="reply.reactions"></comment-reaction>
										<button for="reply" type="button" @click="replyOfReplayOpen(index, key,reply.name )">Reply</button>
									</div>
									<div class="comment-footer-right">
					                    <base-dropdown>
					                        <div slot="title">
												<button type="button">
													<svg width="3px" height="13px" viewBox="0 0 3 13" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
													  <g id="more-vertical" transform="translate(0.5 0.5)">
													    <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" transform="translate(0 4.941176)" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
													    <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
													    <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" transform="translate(0 9.882353)" id="Oval" fill="#214163" stroke="#214163" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
													  </g>
													</svg>
												</button>
					                        </div>
					                        <template>
					                        	<li>
						                            <a href="#">
						                               Block
						                            </a>
					                            </li>
					                        	<li>
						                            <a href="#">
						                               Block & Report
						                            </a>
					                            </li>
					                        </template>
					                    </base-dropdown>
									</div>
								</div>

			 					<!-- Reply of Reply Textarea Start -->
								<div class="reply-textarea" v-if="reply.isReplyOpen">
									<form @submit.prevent="msgReplyOfReply">
										<html-textarea id="reply" v-model="replyOfReply.message"></html-textarea>
										<button type="submit">Reply</button>
									</form>
								</div> 
								<!-- Reply of Reply Textarea End -->

							</div>



						</div>

					</div>
					<!--Comment Wrap End -->



				</div>
			</div>
		</div> <!-- /. comments-wrap -->

	</div>
</template>

<script>

  import truncate from 'vue-truncate-collapsed';
  export default {
      	name: "post-details-comment",

		components: {
		    truncate
		},

		data(){
		    return{
		    	stickyEnabled:true,
		    	shouldStick: false,
		    	message:'',
		    	cmntReply:{
		    		id: '',
		    		message: ''
		    	},
		    	replyOfReply:{
		    		cmndId:'',
		    		replyId: '',
		    		message: ''
		    	},
			    comments:[
			    	{
			    		id:1,
			    		name:'GalGadot',
			    		username:'GalGadot',
			    		photo:'avatar2.png',
			    		time:'09 Juni 2019',
					    reactions:[
				            {
				              userId:1,
				              reaction:'love'
				            },
				            {
				              userId:2,
				              reaction:'wow'
				            }
				        ],
					    hideAllReply:true,
					    isReplyOpen:false,
			    		message:'Barangnya bagus, pengirimannya cepat, pelayanan seller nya juga fast respon dan ramah. Recommend banget pokoknya belanja disini',
			    		replys:[
				    		{
				    			id:1,
					    		name:'Darahelia',
					    		username:'daracantik',
					    		photo: 'avatar.png',
					    		time:'09 Juni 2019',
					    		isReplyOpen:false,
							    reactions:[
						            {
						              userId:1,
						              reaction:'love'
						            },
						            {
						              userId:2,
						              reaction:'wow'
						            }
						        ],
					    		message: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam'
				    		},
				    		{
				    			id:2,
					    		name:'GalGadot',
					    		username:'GalGadot',
					    		photo: 'avatar2.png',
					    		time:'09 Juni 2019',
					    		isReplyOpen:false,
							    reactions:[],
					    		message: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam'
				    		},
				    		{
				    			id:3,
					    		name:'GalGadot',
					    		username:'GalGadot',
					    		photo: 'avatar2.png',
					    		time:'09 Juni 2019',
					    		isReplyOpen:false,
							    reactions:[],
					    		message: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam'
				    		}
			    		]
			    	},
			    	{
			    		id:2,
			    		name:'GalGadot',
			    		username:'GalGadot',
			    		photo:'avatar2.png',
			    		time:'09 Juni 2019',
					    reactions:[],
					    hideAllReply:true,
					    isReplyOpen:false,
			    		message:'Barangnya bagus, pengirimannya cepat, pelayanan seller nya juga fast respon dan ramah. Recommend banget pokoknya belanja disini',
			    		replys:[]
			    	}
			    ],
		    }
		},

		methods: {
			insertMessage() {

				let data = {
					id:this.comments.length+1,
			    	name:'GalGadot',
			    	username:'GalGadot',
			    	photo:'avatar2.png',
			    	time:'09 Juni 2019',
					like:10,
					hideAllReply:true,
					isReplyOpen:false,
			    	message:this.message,
			    	replys:[]
				}
				this.comments.unshift(data);
				this.message=''
			},


			replyTextareaOpen(id, name) {
				this.comments[id].isReplyOpen = !this.comments[id].isReplyOpen;
				this.cmntReply.id = id;
				this.cmntReply.message = "@"+name+' Hi! Terimakasih ';
			},


			replyOfReplayOpen(cmntdId, replaId, name) {
				this.comments[cmntdId].replys[replaId].isReplyOpen = !this.comments[cmntdId].replys[replaId].isReplyOpen;
				this.replyOfReply.cmndId = cmntdId;
				this.replyOfReply.replyId = replaId;
				this.replyOfReply.message = "@"+name+' Hi! Terimakasih ';
			},

			msgReplay() {
				let data = {
	    			id: this.comments[this.cmntReply.id].id,
		    		name: this.comments[this.cmntReply.id].name,
		    		username: this.comments[this.cmntReply.id].username,
		    		photo: this.comments[this.cmntReply.id].photo,
		    		time: this.comments[this.cmntReply.id].time,
		    		isReplyOpen: false,
		    		reactions: this.comments[this.cmntReply.id].reactions,
		    		message: this.cmntReply.message
	    		};

				this.comments[this.cmntReply.id].replys.push(data);
				this.cmntReply.message = '';
				this.comments[this.cmntReply.id].isReplyOpen = !this.comments[this.cmntReply.id].isReplyOpen;
			},

			msgReplyOfReply() {
				let data = {
	    			id: this.comments[this.replyOfReply.cmndId].id,
		    		name: this.comments[this.replyOfReply.cmndId].name,
		    		username: this.comments[this.replyOfReply.cmndId].username,
		    		photo: this.comments[this.replyOfReply.cmndId].photo,
		    		time: this.comments[this.replyOfReply.cmndId].time,
		    		isReplyOpen: false,
		    		reactions: [],
		    		message: this.replyOfReply.message
	    		};

				this.comments[this.replyOfReply.cmndId].replys.push(data);
				this.replyOfReply.message = '';
				this.comments[this.replyOfReply.cmndId].replys[this.replyOfReply.replyId].isReplyOpen = !this.comments[this.replyOfReply.cmndId].replys[this.replyOfReply.replyId].isReplyOpen;
			},


		}
  }

</script>